import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'
import { HttpModule } from '@angular/http';
import { MdlModule } from '@angular-mdl/core';

import { MenubarComponent } from './menubar.component';

@NgModule({
	imports: [
		CommonModule,
		MdlModule,
		HttpModule
	],
	declarations: [
		MenubarComponent
	],
	exports: [ MenubarComponent ]
})
export class MenubarModule { }
